import Image from "next/image";
import {
  HOMEPAGE_HERO_DARK_BG,
  HOMEPAGE_HERO_LIGHT_BG,
} from "@/components/Homepage/HomepageHero/constants";

export default function HomepageHeroBackgroundImage({
  imageSrc,
  screenSize,
  theme = "dark",
}: {
  imageSrc: string;
  screenSize: "mobile" | "tablet" | "desktop";
  theme?: "dark" | "light";
}) {
  const display = {
    mobile: "sm:hidden",
    tablet: "hidden sm:block xl:hidden",
    desktop: "hidden xl:block",
  };
  const bgFallback =
    theme === "light" ? HOMEPAGE_HERO_LIGHT_BG : HOMEPAGE_HERO_DARK_BG;
  return (
    <Image
      src={imageSrc}
      fetchPriority="high"
      alt=""
      className={`object-cover object-right relative z-[-1] m-0 ${display[screenSize]} ${bgFallback}`}
      fill
    />
  );
}
